export default __webpack_public_path__ + "static/template-home-hero-background-fe18a746b036eb0e999e4fe9d12c8fad.jpg";